import { render, staticRenderFns } from "./ProductName.vue?vue&type=template&id=10806937"
import script from "./ProductName.vue?vue&type=script&lang=js"
export * from "./ProductName.vue?vue&type=script&lang=js"
import style0 from "./ProductName.vue?vue&type=style&index=0&id=10806937&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports